























import Vue from "vue";
import ItemAdminLinks from '@/components/ItemAdminLinks.vue';
import ItemUniverse from '@/components/ItemUniverse.vue';
import ItemPoll from '@/components/ItemPoll.vue';
import ItemStrip from '@/components/ItemStrip.vue';
import ItemGoggle from '@/components/ItemGoggle.vue';
import ItemMinichatLine from '@/components/ItemMinichatLine.vue';
import ItemProfile from '@/components/ItemProfile.vue';
import EditItem from '@/components/EditItem.vue';
import { Item } from '../itemtypes';
import { IMAGE_BASE_URL } from '../constants';

export default Vue.extend({

    components: {
        ItemAdminLinks,
        ItemUniverse,
        ItemPoll,
        ItemStrip,
        ItemGoggle,
        ItemMinichatLine,
        ItemProfile,
        EditItem,
    },

    props: {
        item: {
            type: Object,
            default: null,
        },
        context: {
            type: String,
            default: '',
        },
    },

    computed: {
        imageUrl(): string {
            return `${IMAGE_BASE_URL}/${this.item.image}`;
        },
    },

});
